module.exports = __webpack_public_path__ + "img/UpdatedLandingcomLogo4.54eaf86f.png";